export type Tab = 'current' | 'insights' | 'historical' | 'report';

/**
 * Each tab has a shareable URL. Kept apart from the provider so the mapping can
 * be unit tested and reused by the server, which must serve the app shell for
 * every one of these paths.
 */
export const TAB_PATHS: Record<Tab, string> = {
  current: '/',
  insights: '/insights',
  historical: '/historical',
  report: '/report',
};

export const TAB_ROUTES: string[] = Object.values(TAB_PATHS);

/** Anything unrecognised falls back to the default tab rather than 404-ing. */
export function tabFromPath(pathname: string): Tab {
  const normalised = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  const match = (Object.keys(TAB_PATHS) as Tab[])
    .find((tab) => TAB_PATHS[tab] === normalised);
  return match ?? 'current';
}
